<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <span class="headline" style="font-size:1.3rem!important">Recognised Revenue</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-card-text style="padding: 10px">
          <div>
            <v-autocomplete
              class="autocomplete-filter mb-5"
              :items="AMCC"
              item-value="id"
              item-text="name"
              label="AM, CC"
              v-model="selectedFilter.AMCC"
              clearable
              hide-details
              outlined
              dense
              @change="changeFilter"
            ></v-autocomplete>
          </div>
          <v-data-table
            dense
            :headers="computedHeaders"
            :search="filter"
            :items="monthYearValues"
            :key="dataTableKey"
            hide-default-footer
            :items-per-page="-1"
            class="recognized-revenue-table elevation-1">
            <template v-slot:[`item.month`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.month">{{item.month}}</span>
              </td>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.amount">${{item.amount | thousandSeprator}}</span>
              </td>
            </template>
            <!-- <template v-slot:[`item.unallocatedAmt`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.unallocatedAmt">${{item.unallocatedAmt | thousandSeprator}}</span>
              </td>
            </template>
            <template v-slot:[`item.totalRevenue`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.totalRevenue">${{item.totalRevenue | thousandSeprator}}</span>
              </td>
            </template>
            <template v-slot:[`item.allocatedCampaigns`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.allocatedCampaigns">{{item.allocatedCampaigns | thousandSeprator}}</span>
              </td>
            </template> -->
            <template v-slot:[`item.filteredAmt`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.filteredAmt">${{item.filteredAmt | thousandSeprator}} ({{getRevPercent(item)}}%)</span>
              </td>
            </template>
            <template slot="body.append">
              <tr>
                <th style="font-size:14px"><b>Total {{currentYear}}</b></th>
                <th style="font-size:14px"><b>${{ totalAmount | thousandSeprator }}</b></th>
                <!-- <th style="font-size:14px"><b>${{ unallocatedAmt | thousandSeprator }}</b></th>
                <th style="font-size:14px"><b>${{ totalRevenue | thousandSeprator }}</b></th>
                <th style="font-size:14px"><b>${{ allocatedCampaigns | thousandSeprator }}</b></th> -->
                <th style="font-size:14px" v-if="selectedFilter && selectedFilter.AMCC"><b>${{ totalFilteredAmount | thousandSeprator }} ({{totalFilterPercent}}%)</b></th>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import moment from 'moment'
export default {
  name: 'RecognizedRevenueModal',
  props: [
    'value',
    'masterlists',
    'monthYearValues',
    'AM',
    'CC',
    'selectedYear'
  ],
  data() {
    return {
      AMCC: [],
      selectedFilter: {
        AMCC: ''
      },
      headers: [
        {
          text: 'Month',
          value: 'month'
        },
        {
          text: 'Recognised Revenue',
          value: 'amount'
        }
        // {
        //   text: 'Unallocated Revenue',
        //   value: 'unallocatedAmt'
        // },
        // {
        //   text: 'Total Revenue',
        //   value: 'totalRevenue'
        // },
        // {
        //   text: 'Allocated Campaigns',
        //   value: 'allocatedCampaigns'
        // }
      ],
      filteredMthYearVals: []
    }
  },
  computed: {
    computedHeaders() {
      let headers = Object.assign([], this.headers)
      if (this.selectedFilter && this.selectedFilter.AMCC) {
        if (this.selectedFilter.AMCC !== 'Empty') {
          let matchAM = this.AMCC.find(a => a.id === this.selectedFilter.AMCC)
          if (matchAM) {
            headers.push({
              text: `Revenue ${matchAM.firstName} ${matchAM.lastName || ''}`,
              value: 'filteredAmt'
            })
          }
        }
      }
      return headers
    },
    currentYear: function() {
      return moment().format('YYYY')
    },
    totalAmount: function() {
      let total = 0
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(m => {
          if (m.amount) {
            total += parseFloat(m.amount)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    unallocatedAmt: function() {
      let total = 0
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(m => {
          if (m.unallocatedAmt) {
            total += parseFloat(m.unallocatedAmt)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    totalRevenue: function() {
      let total = 0
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(m => {
          if (m.totalRevenue) {
            total += parseFloat(m.totalRevenue)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    allocatedCampaigns: function() {
      let total = 0
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(m => {
          if (m.allocatedCampaigns) {
            total += parseFloat(m.allocatedCampaigns)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    totalFilteredAmount: function() {
      let total = 0
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(m => {
          if (m.filteredAmt) {
            total += parseFloat(m.filteredAmt)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    totalFilterPercent: function() {
      return ((this.totalFilteredAmount / this.totalAmount) * 100).toFixed(2)
    }
  },
  watch: {
    value: async function (newValue) {
      this.AMCC = Object.assign([], [...this.AM, ...this.CC])
      this.AMCC = this.AMCC.filter(a => a.id !== 'Empty')
      this.filteredMthYearVals = Object.assign([], this.monthYearValues)
    }
  },
  methods: {
    getRevPercent(item) {
      return ((item.filteredAmt / item.amount) * 100).toFixed(2)
    },
    changeFilter() {
      this.filteredMthYearVals = this.filteredMthYearVals.map(f => {
        f.filteredAmt = 0
        return f
      })
      if (this.selectedFilter.AMCC) {
        let filteredMasterLists = Object.assign([], this.masterlists)
        filteredMasterLists = filteredMasterLists.filter(i => {
          let AMs = i.AM.map(a => a.id)
          if (AMs.includes(this.selectedFilter.AMCC)) {
            return true
          }
          let CCs = i.CC.map(a => a.id)
          if (CCs.includes(this.selectedFilter.AMCC)) {
            return true
          }
          return false
        })
        for (let item of filteredMasterLists) {
          if (item.monthlyRates) {
            for (let [key, value] of Object.entries(item.monthlyRates)) {
              let revMYIdx = this.filteredMthYearVals.findIndex(rev => (rev.month).replace(' ', '') === key)
              if (revMYIdx !== -1) {
                this.filteredMthYearVals[revMYIdx].filteredAmt += parseFloat(value)
              }
            }
          }
        }
      }
    },
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
  .autocomplete-filter {
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// RecognizedRevenueModal.vue?b1c1dd40